import { render, staticRenderFns } from "./EditableSelect.vue?vue&type=template&id=647e4228&scoped=true&"
import script from "./EditableSelect.vue?vue&type=script&lang=ts&"
export * from "./EditableSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647e4228",
  null
  
)

export default component.exports